<template>
  <v-row>
    <v-col col="12" md="8" offset-md="2" lg="6" offset-lg="3">
      <v-simple-table v-if="asyncDataStatus_ready">
        <template v-slot:default>
          <tbody>
            <tr>
              <td>Ime:</td>
              <td>{{ myCompany.name }}</td>
            </tr>
            <tr>
              <td>Ulica:</td>
              <td>{{ myCompany.address }}</td>
            </tr>
            <tr>
              <td>Poštna številka:</td>
              <td>{{ myCompany.post_code }}</td>
            </tr>
            <tr>
              <td>Mesto:</td>
              <td>{{ myCompany.city }}</td>
            </tr>
            <tr>
              <td>Država:</td>
              <td>{{ myCompany.country }}</td>
            </tr>
            <tr>
              <td>Davčna številka:</td>
              <td>{{ myCompany.tax_number }}</td>
            </tr>
            <tr>
              <td>Matična številka:</td>
              <td>{{ myCompany.register_number }}</td>
            </tr>
            <tr>
              <td>Številka računa:</td>
              <td>{{ myCompany.account_number }}</td>
            </tr>
            <tr>
              <td>Kontaktna oseba:</td>
              <td>{{ myCompany.contact }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  mixins: [
    asyncDataStatus
  ],
  computed: {
    myCompany () {
      return this.$store.state.companies.myCompany
    }
  },
  methods: {
    ...mapActions('companies', ['loadMyCompany'])
  },
  created () {
    this.loadMyCompany()
      .then(myCompany => { this.asyncDataStatus_fetched() })
  }
}
</script>
